import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errText } from "@/lib/api";

export const ChangePasswordCard = () => {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 8) return toast.error("Use at least 8 characters");
    if (form.new_password !== form.confirm) return toast.error("The two new passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("Password updated — use it the next time you sign in");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  const fields = [
    ["current_password", "Current password", "Leave blank if you signed up with Google"],
    ["new_password", "New password", "At least 8 characters"],
    ["confirm", "Confirm new password", ""],
  ];

  return (
    <form onSubmit={submit} className="rounded-2xl border border-border p-6 md:p-8" data-testid="change-password-form">
      <h2 className="flex items-center gap-2 font-display text-lg">
        <KeyRound className="h-4 w-4 text-primary" /> Change password
      </h2>
      <p className="mt-1.5 text-[13px] text-muted-foreground">
        Updating your password signs you out of every other device.
      </p>
      <div className="mt-5 grid gap-5 sm:grid-cols-3">
        {fields.map(([k, label, hint]) => (
          <div key={k} className="space-y-1.5">
            <Label className="text-xs font-semibold">{label}</Label>
            <Input
              type="password"
              autoComplete={k === "current_password" ? "current-password" : "new-password"}
              value={form[k]}
              onChange={(e) => setForm({ ...form, [k]: e.target.value })}
              className="h-12 rounded-lg"
              data-testid={`${k.replace(/_/g, "-")}-input`}
            />
            {hint && <p className="text-[11px] text-muted-foreground">{hint}</p>}
          </div>
        ))}
      </div>
      <Button
        type="submit"
        disabled={busy}
        className="mt-6 h-12 rounded-lg font-bold hover:brightness-95"
        data-testid="change-password-submit-btn"
      >
        {busy ? "Updating…" : "Update password"}
      </Button>
    </form>
  );
};

export default ChangePasswordCard;
